<template>
  <a
    :class="[
      data.wildscreen ? 'count-down-wild' : 'container',
      { 'cursor-default': !category_path },
    ]"
    :href="category_path || 'javascript:;'"
    style="display:block"
  >
    <div
      class="home-count-down"
      :class="[data.align, { 'home-count-down--unStarted': !start }]"
      v-if="onOff"
      :style="{
        color: data.text_color,
        background:data.bg_color
      }"
    > 
    <div class="count-down-bg" v-if="data.bg_type =='image'&&(data.bg_image_object&&data.bg_image_object.url)">
      <v-lazy-img :data-url="data.bg_image_object.url"></v-lazy-img>
    </div>
      <div class="before-tip" v-if="before_tip">
        <p>{{ before_tip }}</p>
      </div>
      <div
        class="tip tip-ing"
        :style="data.align == 'left' ? 'order:-1' : ''"
        v-if="start"
      >
        <div
          class="time-item"
          :class="index != 0 && index != down.length - 1 ? 'two-dot' : ''"
          v-for="(item, index) in down"
          :key="index"
        >
          <span
            :style="{
              background: data.countdown_bg_color,
              color: data.countdown_text_color,
            }"
            class="item"
            v-for="(items, indexs) in item.value"
            :key="index + indexs"
            >{{ items }}</span
          >
          <p v-if="data.show_note" :style="{ color: data.note_color }">
            {{ item.name }}
          </p>
        </div>
      </div>
      <p
        class="tip tip-ed"
        :style="[data.align == 'left' ? 'order:1' : '']"
        v-else
      >
        Promotion starts at {{ date }}
      </p>
      <div class="after-tip" v-if="after_tip">
        <p>{{ after_tip }}</p>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {
      down: [],
      date: "",
      before_tip: null,
      after_tip: null,
      start: false, // 开始，未开始 开关
      onOff: true, // 组件开关
      category_path: "", // 组件开关
    };
  },
  methods: {
    countTime() {
      // 当前日期大于设置开始日期
      let now = new Date().getTime();
      let end = new Date(this.data.date).getTime();
      let leftTime = end - now;
      if (new Date() >= new Date(this.data.date)) {
        if (this.data.align == "left" || this.data.align == "right") {
          this.before_tip =
            this.data.text &&
            this.data.text.progressive &&
            this.data.text.progressive.text;
        } else {
          this.before_tip =
            this.data.text &&
            this.data.text.progressive &&
            this.data.text.progressive.before;
          this.after_tip =
            this.data.text &&
            this.data.text.progressive &&
            this.data.text.progressive.after;
        }
        let count = Number(this.data.timer.number);

        if (this.data.timer.type == "Hours") {
          end = end + count * 60 * 60 * 1000;
        } else if (this.data.timer.type == "Minutes") {
          end = end + count * 60 * 1000;
        } else {
          end = end + count * 60 * 24 * 60 * 1000;
        }
        let leftTime = end - now;
        let d, h, m, s;
        if (leftTime >= 0) {
          d = Math.floor(leftTime / 1000 / 60 / 60 / 24)
            .toString()
            .padStart(2, "0");
          h = Math.floor((leftTime / 1000 / 60 / 60) % 24)
            .toString()
            .padStart(2, "0");
          m = Math.floor((leftTime / 1000 / 60) % 60)
            .toString()
            .padStart(2, "0");
          s = Math.floor((leftTime / 1000) % 60)
            .toString()
            .padStart(2, "0");
          this.down = [
            { name: "DAYS", value: d },
            { name: "HOURS", value: h },
            { name: "MINUTES", value: m },
            { name: "SECONDS", value: s },
          ];
          this.start = true;
          setTimeout(this.countTime, 1000);
        } else {
          this.onOff = false;
        }
        //将倒计时赋值到div中
      } else {
        setTimeout(this.countTime, leftTime);
        if (this.data.align == "left" || this.data.align == "right") {
          this.before_tip =
            this.data.text &&
            this.data.text.notstarted &&
            this.data.text.notstarted.text;
        } else {
          this.before_tip =
            this.data.text &&
            this.data.text.notstarted &&
            this.data.text.notstarted.before;
          this.after_tip =
            this.data.text &&
            this.data.text.notstarted &&
            this.data.text.notstarted.after;
        }
        if (this.data.before_start_show) {
          this.onOff = false;
        } else {
          this.date = new Date(this.data.date).format("yyyy.MM.dd HH:mm:ss");
          this.start = false;
        }
      }

      //递归每秒调用countTime方法，显示动态时间效果
    },
  },
  beforeMount() {},
  mounted() {
    let { category_path, category } = this.data;
    if (category_path && category && category.length) {
      this.category = category;
      this.category_path = category_path;
    }
    console.log("countDown", this.data);
    this.countTime();
    // console.log(this.data);
    // if (this.data && this.data.date && this.data.timer) {
    //   this.getendtime(this.data.date, this.data.timer);
    // }
  },
};
</script>

<style lang="scss" scoped>
.count-down-wild {
  .home-count-down {
    min-height: 100px;
    p {
      font-size: 32px;
      font-weight: 600;
    }
  }
}
.home-count-down {
  position: relative;
  width: 100%;
  min-height: 100px;
  padding: 18px 30px;
  background: linear-gradient(90deg, #b564d9, #ee609c);
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  color: #fff;
  .two-dot {
    position: relative;
  }
  &>*:not(.count-down-bg){
    z-index: 2;
  }
  .two-dot::after,
  .two-dot::before {
    content: "";
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    background: #fff;
    position: absolute;
    right: -12%;
    z-index: 2;
  }
  .two-dot::after {
    top: 20%;
  }
  .two-dot::before {
    top: 50%;
  }
  .tip {
    display: flex;
  }
  .count-down-bg{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    img{
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .before-tip {
    margin: 5px 60px 17px 0;
  }
  .after-tip {
    margin: 5px 0 17px 40px;
  }
  .tip-ed {
    color: #000;
    background: #fff;
    opacity: 0.8;
    padding: 0 20px;
    border-radius: 6px;
    line-height: 36px;
  }
  p {
    font-size: 26px;
  }
  .time-item {
    display: inline-block;
    margin-right: 16px;
    &:last-child() {
      margin-right: 0;
    }
    .item {
      background: #ffffff;
      color: #000;
      text-align: center;
      margin-right: 2px;
      font-size: 28px;
      font-weight: 500;
      min-width: 36px;
      line-height: 48px;
      display: inline-block;
      border-radius: 6px;
      font-weight: 600;
      &:last-child() {
        margin-right: 0;
      }
    }
    p {
      text-align: center;
      font-size: 12px;
      color: #fff;
      margin-top: 4px;
      font-weight: normal;
    }
  }
}
.home-count-down.left{
  justify-content: flex-start;
}
.home-count-down.center{
  justify-content: center;
}
.home-count-down.right{
  justify-content: flex-end;
}
.home-count-down--unStarted {
  .before-tip,
  .after-tip {
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
@media (max-width: 767px) {
  .count-down-wild {
    .home-count-down {
      min-height: unset;
      p {
        font-size: 14px;
      }
      .time-item {
        p {
          font-size: 12px;
          zoom: 0.67;
        }
      }
      .two-dot::before {
        top: 49%;
      }
      .two-dot::after {
        top: 28%;
      }
    }
  }
  .home-count-down {
    padding: 10px;
    p {
      font-size: 18px;
    }
    .time-item {
      margin-right: 8px;
      .item {
        font-size: 14px;
        min-width: 18px;
        line-height: 24px;
        border-radius: 5px;
      }
    }
    .two-dot::after,
    .two-dot::before {
      width: 3px;
      height: 3px;
      right: -10%;
    }
    .two-dot::before {
      top: 50%;
    }
    .two-dot::after {
      top: 15%;
    }
    .before-tip {
      margin: 5px 5px 10px 0;
    }
    .after-tip {
      margin: 5px 0 10px 5px;
    }
  }
}
</style>